import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import Container from "../Container";
import { H2, AccentTitle } from "../Typography";
import Box from "react-raster";

const FullWidthWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
`;

const LogosWrapper = styled.div`
  justify-items: center;
  align-items: flex-end;
  display: grid;
  grid-template-columns: ${({ $numberOfColumns }) =>
    `repeat(${$numberOfColumns}, 1fr)`};
  width: 100%;
  @media (max-width: ${({ theme }) => `${theme.breakpoints[1]}px`}) {
    display: block;
  }
`;

const Client = styled.div`
  max-width: 60%;
  padding: 0 20px;
  @media (max-width: ${({ theme }) => `${theme.breakpoints[1]}px`}) {
    max-width: 75%;
    padding: 0 30px;
  }
`;

const ImageWrapper = styled.div`
  img {
    max-width: 100%;
  }
`;

export const Meta = styled.div`
  margin-top: 20px;
  border-top: 1px solid #ffffff;
  min-height: 75px;
  margin-bottom: 20px;
`;

const CompanyName = styled(AccentTitle)`
  color: ${({ theme, $backgroundColour }) =>
    $backgroundColour !== "white" ? theme.colours.white : theme.colours.black};
`;

export const SubTitle = styled.small`
  display: block;
  font-family: "supply", monospace;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.9px;
  color: ${({ theme, $backgroundColour }) =>
    $backgroundColour !== "white" ? theme.colours.white : theme.colours.black};
`;

/**
 * @param {clientLogo} array - despite the name, an array of objects,
 *                             each with an id, logo, companyName and subTitle
 * @returns a React component
 */
function ClientLogos({
  backgroundColour,
  title,
  showTitle,
  clientLogo,
  hasBottomMargin,
  numberOfColumns,
}) {
  return (
    <FullWidthWrapper $backgroundColour={backgroundColour}>
      <Container
        hasBottomMargin={hasBottomMargin}
        paddingBottom={["20px", "40px"]}
        paddingTop={["20px", "40px"]}
      >
        <Box
          cols={[6, 12]}
          marginTop={["20px", "0"]}
          marginBottom={["20px", "0"]}
        >
          {showTitle && (
            <H2 $colour={backgroundColour !== "white" && "white"}>{title}</H2>
          )}
        </Box>
        <Box cols={[6, 12]}>
          <LogosWrapper $numberOfColumns={numberOfColumns}>
            {clientLogo?.map((logoObj) => {
              const { id, logo, companyName, subTitle, url } = logoObj;
              return (
                <Client key={id}>
                  {url ? (
                    <Link to={url} target="_blank">
                      {logo.file?.url && (
                        <ImageWrapper>
                          <img
                            src={logo.file?.url}
                            alt={companyName || subTitle}
                          />
                        </ImageWrapper>
                      )}
                    </Link>
                  ) : (
                    logo.file?.url && (
                      <ImageWrapper>
                        <img
                          src={logo.file?.url}
                          alt={companyName || subTitle}
                        />
                      </ImageWrapper>
                    )
                  )}
                  {(companyName || subTitle) && (
                    <Meta>
                      {companyName && <CompanyName>{companyName}</CompanyName>}
                      {subTitle && <SubTitle>{subTitle}</SubTitle>}
                    </Meta>
                  )}
                </Client>
              );
            })}
          </LogosWrapper>
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default ClientLogos;
